<div [formGroup]="form">
  <p-select class="w-full" styleClass="w-full" [placeholder]="placeholder" [options]="options"
    formControlName="staff" appendTo="body" [filter]="true" filterBy="first, last, nickname"
    [virtualScroll]="virtualScroll" [virtualScrollItemSize]="virtualScrollItemSize"
    (onBlur)="markAsTouched()">
    <ng-template pTemplate="selectedItem">
      @if (!value) {
        <div class="p-dropdown-label-empty">empty</div>
      }
      <div class="flex gap-2">
        {{value | staffDisplay}}
        <div class="flex gap-1">
          @for (icon of iconMap.get(value?.id ?? 0); track icon) {
            <fa-icon [icon]="icon.icon"
            [pTooltip]="icon.tooltip" [showDelay]="300"></fa-icon>
          }
        </div>
      </div>
    </ng-template>
    <ng-template let-staff pTemplate="item">
      <div class="flex justify-between gap-2">
        <div class="flex items-center gap-2">
          @if (preferences.staffDropdownPhotos) {
            <app-staff-photo [staffId]="staff.id"
            size="small"></app-staff-photo>
          }
          @if (staff.title !== 'Unassigned') {
            <div>{{staff | staffDisplay}}</div>
          } @else {
            <div>Set to Unassigned</div>
          }
        </div>

        <div class="flex gap-1">
          @for (icon of iconMap.get(staff.id); track icon) {
            <fa-icon [icon]="icon.icon" [pTooltip]="icon.tooltip"
            [showDelay]="300"></fa-icon>
          }
        </div>
      </div>
    </ng-template>
  </p-select>

</div>